import { render } from "./FullscreenDesktop.vue?vue&type=template&id=3db4a286&scoped=true"
import script from "./FullscreenDesktop.vue?vue&type=script&lang=js"
export * from "./FullscreenDesktop.vue?vue&type=script&lang=js"

import "./FullscreenDesktop.vue?vue&type=style&index=0&id=3db4a286&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db4a286"]])

export default __exports__